import React, { createContext, useContext, useState, useEffect } from 'react';

const AIContext = createContext();

export const useAI = () => {
  const context = useContext(AIContext);
  if (!context) throw new Error('useAI must be used within AIProvider');
  return context;
};

export const AIProvider = ({ children }) => {
  const [aiEnabled, setAiEnabled] = useState(true);

  useEffect(() => {
    try {
      const saved = localStorage.getItem('aiEnabled');
      if (saved !== null) setAiEnabled(saved === 'true');
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem('aiEnabled', aiEnabled ? 'true' : 'false');
    } catch (e) {}
  }, [aiEnabled]);

  const toggleAI = () => setAiEnabled((v) => !v);

  return (
    <AIContext.Provider value={{ aiEnabled, setAiEnabled, toggleAI }}>
      {children}
    </AIContext.Provider>
  );
};

export default AIContext;
